<template>
  <div>
    <div class="empty" v-if="empty" @click="showProduct = true">
      <p>
        <i class="el-icon-circle-plus"></i>
        <span>点击添加商品</span>
      </p>
    </div>
    <div class="product-box" v-else>
      <div class="product-info">
        <el-image class="icon" :src="product.icon" fit="cover"></el-image>
        <div class="right-part">
          <p class="header">{{ product.name }}{{ product.tag }}</p>
          <p class="content">ID: {{ product.id }}</p>
        </div>
      </div>
      <span class="change-button" @click="handleChangeProduct">更换</span>
    </div>

    <el-drawer
      class="drawer"
      :size="840"
      :visible.sync="showProduct"
      :with-header="false"
    >
      <p class="title">添加商品</p>
      <div class="search">
        <el-input
          size="medium"
          placeholder="请输入商品名称/ID搜索"
          v-model="searchProduct"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="main">
        <product-form @change="handleChange" />
      </div>
      <div class="bottom">
        <p style="float: left; margin-top: 8px">
          找不到商品？
          <el-popover placement="top" trigger="hover" width="303">
            <div style="min-width: 320px; padding: 5px">
              <p class="t-title">商品要求</p>
              <p class="t-r">1、商品状态为审核通过且上架</p>
              <p class="t-r">2、商品为非全款预售</p>
              <p class="t-r">
                3、商品类目为以下类目：<a
                  href="https://bytedance.feishu.cn/docs/doccnQF3XLhf0nI3tj6UQS2LBie"
                  target="_blank"
                  rel="noopener noreferrer"
                  >查看类目要求</a
                >
              </p>
            </div>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>

        <div class="right-btns">
          <div
            class="btn next"
            :class="{ disabled: !currentProduct }"
            @click="handleComfirm"
          >
            确定
          </div>
          <div class="btn" @click="showProduct = false">取消</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import productForm from "./products.vue";

export default {
  components: {
    productForm,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      empty: true,
      showProduct: false,
      searchProduct: "",
      currentProduct: null,
    };
  },
  methods: {
    handleChange(val) {
      this.currentProduct = val;
    },
    handleComfirm() {
      if (!this.currentProduct) return;
      this.$emit("onConfirm", this.currentProduct);
      this.empty = false;
      this.showProduct = false;
    },
    // 退出提示
    handleChangeProduct() {
      this.$confirm("更换商品后将清空已有创意内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.showProduct = true;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.empty {
  width: 648px;
  height: 80px;
  background-color: #fff;
  border: 1px dashed #c1c1c1;
  border-radius: 4px;
  line-height: 80px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  text-align: center;
  letter-spacing: 2px;
  place-items: center;
  cursor: pointer;
  &:hover {
    color: #194ce5;
  }
}
.product-box {
  padding-right: 24px;
  border-radius: 4px;
  width: 648px;
  height: 80px;
  background: #f2f2f2;
  overflow: hidden;
  .product-info {
    display: inline-block;
    width: 482px;
    .icon {
      width: 78px;
      height: 78px;
    }
    .right-part {
      display: inline-block;
      margin-top: 18px;
      margin-left: 12px;
      width: 392px;
      vertical-align: top;
      .header {
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        color: #333;
        white-space: nowrap;
      }
      .content {
        margin-top: 8px;
        line-height: 20px;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .change-button {
    margin-left: 100px;
    line-height: 20px;
    color: #194ce5;
    vertical-align: 30px;
    cursor: pointer;
  }
}
::v-deep .drawer {
  .el-drawer__body {
    position: relative;
    padding: 16px 24px 0;
    color: #333;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #111;
    }
    .search {
      margin-top: 24px;
      margin-bottom: 24px;
      .el-input {
        width: 285px;
        .el-input-group__append {
          padding: 0;
          width: 34px;
          height: 34px;
          .el-button {
            padding: 0;
            margin: 0;
            width: 34px;
            height: 34px;
            color: #fff;
            background-color: #194ce5;
            border-color: #194ce5;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            &:hover {
              background-color: #436dea;
              border-color: #436dea;
            }
          }
        }
      }
    }
  }
  .main {
    height: calc(100vh - 16px - 24px - 48px - 36px - 66px - 1px);
  }
  .bottom {
    margin: 0 -24px;
    padding: 16px 24px;
    border-top: 1px solid #e5e5e5;
    height: 66px;
    background-color: #fff;
    overflow: hidden;
    .el-icon-question {
      font-size: 16px;
      color: #c0c4cc;
      vertical-align: middle;
      cursor: pointer;
    }
    .right-btns {
      overflow: hidden;
      .btn {
        float: right;
        min-width: 100px;
        padding: 5px 16px;
        border-radius: 4px;
        text-align: center;
        line-height: 22px;
        color: #333;
        background: #fff;
        border-color: #999;
        border: 1px solid #dcdde0;
        transition: all 0.3s ease;
        cursor: pointer;
        &:hover {
          background: #edf1fd;
          border-color: #194ce5;
        }
        &.next {
          margin-left: 8px;
          color: #fff;
          background: #1966ff;
          border: 1px solid transparent;
          &:hover {
            background: #4784ff;
          }
          &.disabled {
            color: #edf1fd;
            background-color: #98aff4;
            border-color: #98aff4;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.t-title {
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #333;
}
.t-r {
  color: #666;
  font-size: 12px;
  line-height: 22px;
  a {
    color: #194ce5;
  }
}
</style>